
import { defineComponent, PropType } from "vue";
import { IKhoResponseBase } from "@/core/interfaces/ApiResponses";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import { getErrorMsg, swalNotification } from "@/core/helpers/utils";
import { KhoService } from "@/core/services/Kho.service";

import ConfirmationDialog from "@/components/confirmation-dialog/ConfirmationDialog.vue";
import Setting from "@/components/shared/setting/Setting.vue";
import type { SettingAction } from "@/components/shared/setting/Setting.vue";
import IconEye from "@/icons/IconEye.vue";
import IconPencil from "@/icons/IconPencil.vue";
import IconTrash from "@/icons/IconTrash.vue";

export default defineComponent({
  name: "danh-sach-kho-table",

  components: { ConfirmationDialog, Setting },

  emits: ["on-delete-kho"],

  setup() {
    const { push } = useRouterCustom();

    return {
      push,
    };
  },

  data: () => ({
    isDeleteKhoConfirmationDialogDisplay: false,
    deletingKho: null as IKhoResponseBase | null,
  }),

  props: {
    items: Array as PropType<Array<IKhoResponseBase>>,
    showDeleteKhoButton: Boolean as PropType<boolean>,
    showEditButton: Boolean as PropType<boolean>,
  },

  methods: {
    getSettingActions(row: IKhoResponseBase): SettingAction[] {
      const actions: SettingAction[] = [
        {
          icon: IconEye,
          label: "Chi tiết kho",
          tooltip: "Chi tiết kho",
          onClick: () => this.push(`/quan-ly/kho/chi-tiet/${row.id}`),
        },
      ];

      if (this.showEditButton) {
        actions.push({
          icon: IconPencil,
          label: "Chỉnh sửa thông tin kho",
          tooltip: "Chỉnh sửa thông tin kho",
          any: ["data:kho:sua"],
          onClick: () => this.push(`/quan-ly/kho/${row.id}/cap-nhat`),
        });
      }

      if (this.showDeleteKhoButton) {
        actions.push({
          icon: IconTrash,
          label: "Xoá kho",
          tooltip: "Xoá kho",
          any: ["data:kho:xoa"],
          onClick: () => this.onDeleteKhoClicked(row.id),
        });
      }

      return actions;
    },

    onDeleteKhoClicked(id: number) {
      const kho = this.items?.find((item) => item.id === id);
      this.isDeleteKhoConfirmationDialogDisplay = true;
      if (kho) {
        this.deletingKho = kho;
      }
    },

    async confirmDelete() {
      this.isDeleteKhoConfirmationDialogDisplay = false;

      try {
        if (this.deletingKho) {
          await KhoService.delete(this.deletingKho.id);
        }
        await swalNotification("Xóa thành công");
        this.$emit("on-delete-kho");
      } catch (e) {
        await swalNotification(
          getErrorMsg(e, "Có lỗi xảy ra khi xóa kho này"),
          "error"
        );
      }
    },
  },
});
